<template>
  <lazy-component @show.once="render(false)">
      <div v-if="isShow">
        <Module ref="Module" class="wendamian"
        :title="'问答'"
        :desc="'暂无问答信息'"
        :moreTitle="'更多问答'"
        :rightBtnDesc="'我要提问'"
        :rightBtnEvent="clickAsk"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :checkData="checkData"
        :showMore="showMore"
        :emptyTitle="'暂无问答信息'"
        :moreEvent="clickMore">
          <div slot-scope="slotProps" class="wendamian">
            <div v-for="(slotItem, slotIndex) in slotProps.list" :key="slotIndex">
              <div class="askTipBack" v-if="slotItem.tiplist && slotItem.tiplist.length > 0">
                <span class="ques-tip-buttonall">全部</span>
                <span class="ques-tip-button"
                      v-for="(item, index) in slotItem.tiplist"
                      :key="index"
                      @click="clickTip(item)">{{item.name}}</span>
              </div>
              <div class="ques-item" v-for="(item, index) in slotItem.list" :key="index"
              @click="clickCell(item)">
                <p class="ques-title">{{item.title}}</p>
                <div class="ques-info">
                  <span class="ques-time">{{getQusTime(item)}}</span>
                  <span class="ques-answerNum" v-if="item.answerNum">{{item.answerNum}}回答</span>
                  <span class="ques-adoptNum" v-if="item.adoptedNum">{{item.adoptedNum}}已采纳</span>
                </div>
              </div>
            </div>
          </div>
        </Module>
      </div>
  </lazy-component>
</template>
<script>
import Util from '@/base/Util';
import {
  userLogin,
  detailPushPage,
} from '@/utils/nativeBridge';
import Module from '@/components/ModuleChoose.vue';
import StoreManger from '@/utils/FundHQJHManger';
// import dataModel from '@/model/question.model';

export default {
  name: 'FundQuestion',
  components: {
    Module,
  },
  props: {
    fundCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nativeData: {},
      // fundCode: '',
      fundType: '',
      isShow: true,
      pageData: [],
      tiplist: [],
    };
  },
  computed: {},
  created() {
    // this.fundCode = this.$store.state.native.fund.fundCode;
    // this.fundType = this.$store.state.native.fund.fundType;
    // this.handleDefault();
  },
  mounted() {
    // this.render();
  },
  methods: {
    getQusTime(item) {
      const res = Util.formatTimeString(item.time);
      return res;
    },
    show() {
      this.isShow = true;
      return this.isShow;
    },
    render(iscache) {
      if (this.show()) {
        this.nativeData = this.$store.state.native.fund;
        // this.fundCode = this.nativeData.fundCode;
        this.fundType = this.nativeData.fundType;
        this.$nextTick(() => {
          if (iscache) {
            this.$refs.Module.cache();
          } else {
            this.$refs.Module.start();
          }
        });
      }
    },
    fetchCache() {
      return this.$store.state.question.fund[this.fundCode];
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('updateQuestion', this.fundCode)
          .then((res) => {
            const tiplist = this.configureTiplist();
            resolve([{
              tiplist,
              list: res.Data,
            }]);
          })
          .catch(() => {
            // console.log('fetchRequest fail');
            reject();
          });
      });
    },
    showMore(data) {
      if (!data) {
        return false;
      }
      if (Object.prototype.toString.call(data) !== '[object Array]') {
        return false;
      }
      if (data.length === 0) {
        return false;
      }
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data[0].list.length > 1);
    },
    checkData(data) {
      if (!data) {
        return false;
      }
      if (Object.prototype.toString.call(data) !== '[object Array]') {
        return false;
      }
      if (data.length === 0) {
        return false;
      }
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data[0].list.length > 0);
    },
    clickTip(item) {
      const { LinkType, LinkTo } = item.link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
    },
    configureTiplist() {
      // 配置标签
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const list = [];
      const tipData = this.$store.state.question.fund[this.fundCode].VarietyDynamicStatistics;
      if (tipData) {
        const { RewardIngCount } = tipData;
        if (RewardIngCount) {
          // 悬赏中
          list.push({
            name: `悬赏中 ${this.getWanCount(RewardIngCount)}`,
            link: {
              LinkType: '2',
              LinkTo: `fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarQuestPage?fundCode=${this.fundCode}&fundName=${name}&index=1`,
            },
          });
        }
      }
      return list;
    },
    getWanCount(count) {
      if (count) {
        if (parseFloat(count) > 10000) {
          //
          return `${parseFloat(parseFloat(count) / 10000)}万`;
        }
        return count;
      }
      return '';
    },
    handleDefault() {
      // this.pageData = dataModel.objectArrayWithKeyValuesArray([{}], [{}]);
    },
    clickCell(item) {
      detailPushPage({
        type: 1,
        url: `fund://page/barQuestionDetail?postid=${item.postId}&qid=${item.questionId}`,
      });
      this.reportMonitor({
        eventName: 'pz.xx.gk.wd',
      });
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarQuestPage?fundCode=${this.fundCode}&fundName=${name}`,
      });
      this.reportMonitor({
        eventName: 'pz.xx.gk.wd.more',
        infoCodeType: '5',
        infoCode: this.fundCode,
      });
    },
    clickAsk() {
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        const baseInfo = StoreManger.getFundJJXQ();
        const name = StoreManger.getFundJJXQNAME(baseInfo);
        detailPushPage({
          type: 2,
          url: `fund://mp.1234567.com.cn/weex/48242f55e8704a59a9344e9582cc9724/pages/singleBar/singleBarQuestPage?fundCode=${this.fundCode}&fundName=${name}`,
        });
        return;
      }
      // #endif
      userLogin().then(() => {
        this.askaction();
      }).catch(() => {

      });
      this.reportMonitor({
        eventName: 'pz.xx.gk.tw',
      });
    },
    askaction() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      detailPushPage({
        type: 1,
        url: `fund://page/questionPost?fundcode=${this.fundCode}&fundname=${name}`,
      });
    },
  },
};
</script>

<style scoped lang="less">
.topsp {
  margin-top: -88px;
}
.wendamian {
  border-radius: 12px;
}
.ques-title {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #000000;
  letter-spacing: 0;
  text-align: justify;
  line-height: 44px;
}
.askTipBack{
  background-color: #ffffff;
  border-bottom: 0px solid #EEEEEE;
  padding: 30px;
  padding-bottom: 0;
  display: flex;
  flex-direction: row;
  align-items: left;
  flex-wrap: wrap;
}
.ques-tip-buttonall{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 28px;
  padding: 0px 24px;
  margin-right: 20px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
    color: #ff4400;
    background: #fff0eb;
}
.ques-tip-button{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-radius: 28px;
  padding: 0px 24px;
  margin-right: 20px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #333333;
  background: #f5f5f5;
}
.ques-item {
  background-color: #ffffff;
  margin-left: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 30px;
  &:nth-last-child(1) {
    &:after{
      display: none;
    }
  }
}

.ques-time,
.ques-answerNum,
.ques-adoptNum {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #999999;
  letter-spacing: 0;
  text-align: justify;
  line-height: 26px;
}

.ques-info {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.ques-time {
  flex: 1;
}

.ques-adoptNum {
  margin-left: 12px;
}
</style>
